var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "255.000000pt",
    height: "267.000000pt",
    viewBox: "0 0 255.000000 267.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,267.000000) scale(0.100000,-0.100000)",
    fill: "current",
    stroke: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91 2443 l-91 -228 0 -927 0 -928 330 0 330 0 0 -180 0 -180 163 0 162 0 180 180 180 180 255 0 255 0 348 348 347 347 0 808 0 807 -1184 0 -1184 0 -91 -227z m2219 -660 l0 -648 -192 -192 -193 -193 -315 0 -315 0 -182 -182 -183 -183 0 183 0 182 -270 0 -270 0 0 840 0 840 960 0 960 0 0 -647z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050 1635 l0 -345 105 0 105 0 0 345 0 345 -105 0 -105 0 0 -345z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1680 1635 l0 -345 105 0 105 0 0 345 0 345 -105 0 -105 0 0 -345z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitch);
export default __webpack_public_path__ + "static/media/Twitch.a8c625fe309815cfebc0396d17c139c7.svg";
export { ForwardRef as ReactComponent };